export enum AccountDetailFields {
	ACCOUNT_NUMBER = 'accountNumber',
	IFSC = 'ifsc',
	ACCOUNT_HOLDER_NAME = 'bankCustomerName',
	ACCOUNT_TYPE = 'accountType',
}

export enum AccountTypeOptions {
	SAVINGS = 'SAVINGS',
	CURRENT = 'CURRENT',
}

export type TEnachAccountType = `${AccountTypeOptions}`;

export interface IEnachAccountFormData {
	accountNumber: string;
	ifsc: string;
	bankCustomerName: string;
	accountType: TEnachAccountType | '';
}

export interface IEnachFormErrors {
	accountNumber?: string;
	ifsc?: string;
	bankCustomerName?: string;
	accountType?: string;
}

export type IEnachAccountFormDisabledFields = Record<
	AccountDetailFields,
	boolean
>;

export type ValidationRule =
	| {
			type: 'LENGTH';
			validationId: string;
			message: string;
			active: boolean;
			maxLength: number;
			minLength: number;
			/** Minimum characters user must type before showing validation errors */
			showErrorAfterLength?: number;
	  }
	| {
			type: 'REGEX';
			validationId: string;
			message: string;
			active: boolean;
			regex: RegExp;
			/** Minimum characters user must type before showing validation errors */
			showErrorAfterLength?: number;
	  };

/**
 * Defines the structure for the validation result object.
 */
export interface ValidationResult {
	isValid: boolean;
	errorMessage: string;
}

/**
 * Options for field validation behavior.
 */
export interface ValidateFieldOptions {
	/** When true, shows all errors regardless of input length (e.g., on form submit) */
	forceValidation?: boolean;
}
